// passar array, texto para pesquisa e as chaves (nomes das propriedades) que seram procuradas

export function filterArrayBy(
  array: any[] = [{}],
  searchText: string = "",
  findKeys: string[] = [],
  sortBy?: string
) {
  let resultArray: any[] = [];
  let indexes: number[] = [];
  const search = searchText
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

  for (let key of findKeys) {
    array.forEach((current, index) => {
      if (typeof current[key] === "string")
        if (
          current[key]
            ?.toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .includes(search)
        )
          indexes.push(index);
    });
  }
  let uniqIndexes: number[] = [...new Set(indexes)];
  for (let index of uniqIndexes) resultArray.push(array[index]);

  if (sortBy) return sortArrayBy(resultArray, sortBy);
  return resultArray;
}

export function sortArrayBy(
  array: any[],
  sortBy: string,
  sortOrder: "ASC" | "DESC" = "ASC"
) {
  return array.sort((a, b) => {
    let curr = a[sortBy];
    let next = b[sortBy];
    if (curr === null) return sortOrder === "ASC" ? -1 : 1;
    if (next === null) return sortOrder === "ASC" ? 1 : -1;
    if (curr < next) return sortOrder === "ASC" ? -1 : 1;
    if (curr > next) return sortOrder === "ASC" ? 1 : -1;
    return 0;
  });
}

export function getArrayMaxValue(values: number[]) {
  let maxValue = 0;
  values.forEach((value) => {
    if (value > maxValue) maxValue = value;
  });
  return maxValue;
}
